/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><es-layout :layout="(['header', 'footer'])" :click-left="(goback)" class="es-add" :custom-class='["contact-add-custom-class"].join(" ")'><div slot="header" class="page-header"><es-navbar custom-class="es-add__navbar" :title="('新增' + title + '信息')" :leftArrow="(false)" class="es-add__navbar"><div slot="left" v-if="(!isHideLeftArrow)"><es-icon size="24" color="#333333" name="angle-left"></es-icon></div></es-navbar></div><es-content ref="__mpx_ref_contentRef__" :source="(source)" :scene="(scene)" :isNeedCard="(isNeedCard)" :category="(category)" :isAddPage="(true)" :isDelay="(isDelay)" @change="changeDialog"/><div slot="footer" class="es-add__footer"><es-button block type="info" @click="saveContact" :custom-class='["es-add__save"].join(" ")'>保存</es-button></div><es-toast id="es-toast"/><es-dialog id="es-dialog"/></es-layout><filling-explanation :show="(isDialogShow)" @close="changeDialog"></filling-explanation></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m04c30daa"}'>
  +b('add')
    /deep/ .es-main
      background-color #f0f1f4
    /deep/ .es-toast
      background-color #000000
      padding 12px 24px
    /deep/ .es-card__body
      padding 0 12px !important
    /deep/ .es-icon-angle-right
      font-size 20px !important
      color #999999 !important
    +e('navbar')
      background-color #ffffff
      height 44px !important
      z-index auto !important
      font-size 18px
      /deep/ .es-navbar
        height 60px
      /deep/ .es-navbar__right
        width 28px
      /deep/ .es-navbar__title
        font-size 18px
    +e('save')
      border-radius 8px !important
      font-size 16px !important
      background-color #FF6400
      border-color #FF6400
      /deep/ button
        border-radius 8px
    +e('footer')
      width 100%
      padding 16px
      background-color #ffffff
      box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
      // z-index 1
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m04c30daa"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./add.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./add.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m04c30daa"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-button':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-dialog':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/dialog/index.mpx?isComponent&outputPath=components%2Findex3651661c%2Findex")),'es-toast':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/toast/index.mpx?isComponent&outputPath=components%2Findex68e47551%2Findex")),'es-content':getComponent(require("./components/content/index.mpx?isComponent&outputPath=components%2Findex5abea267%2Findex")),'filling-explanation':getComponent(require("./components/filling-explanation/index.mpx?isComponent&outputPath=components%2Findex10da3b8e%2Findex")),'es-layout':getComponent(require("../../es-mpx-ui/lib/layout/index.mpx?isComponent&outputPath=components%2Findex2146c876%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
